<template>
  <div @mouseleave="onMouseLeave">
    <span v-for="item, ratingIndex in maxRating" :key="'rating-' + ratingIndex" @mouseover="onMouseOver(ratingIndex)"
          :disabled="readOnly === true"
          @click="onClick(ratingIndex)" :class="{'starActive': hoverRating >= ratingIndex}" style="cursor: pointer;">
      <mu-icon :size="24" value="star" :color="calcStars(ratingIndex)"></mu-icon>
    </span>
  </div>
</template>
<script>
  import RecipeApi from '../../../api/Recipes'

  export default {
    name: "recipe-rating",
    props: {
      rating: {
        type: Number,
        default: 0
      },
      userRating: {
        type: Number,
        default: 0
      },
      count: {
        type: Number,
        default: 0
      },
      recipe: {
        type: Object
      },
      readOnly: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      'rating': 'countInit',
      'count': 'countInit'
    },
    data() {
      return {
        hoverRating: -1,
        maxRating: 5,
        currentRating: 0,
        currentCount: 0
      }
    },
    mounted() {
      let self = this;
      self.currentRating = parseInt(self.rating);
      self.currentCount = parseInt(self.count);
      // self.onClick(4);
    },
    methods: {
      calcStars(id) {
        let self = this;
        if (self.currentRating === 0) {
          return 'gold'
        } else {
          return self.currentRating < (id + 1) ? '#CCCCCC': 'gold'
        }
      },
      countInit() {
        this.currentRating = parseInt(this.rating);
        this.currentCount = parseInt(this.count);
      },
      onClick(ratingIndex) {
        let self = this;
        if (self.readOnly !== true) {
          let model = {
            recipe_id: self.recipe.id,
            rating: (ratingIndex + 1)
          };
          RecipeApi.rate(model)
            .then(function (response) {
              self.$emit('ratingPicked', response.data);
            })
        }
      },
      onMouseOver(ratingIndex) {
        if(this.readOnly !== true) {
          this.hoverRating = (ratingIndex);
        }
      },
      onMouseLeave() {
        if(this.readOnly !== true) {
          this.hoverRating = -1;
        }
      }
    }
  }
</script>
<style>
  span.starActive i {
    color: gold !important;
  }
</style>



// WEBPACK FOOTER //
// RecipeRating.vue?75e2eeae